import { KPOW_REQUESTS } from '../dataSource';
import type { WidgetSchema } from '../types';

export const kpow: WidgetSchema = {
    meta: {
        id: 'kpow',
        category: 'indices',
        categoryTitle: 'Indices',
        title: 'American Power Index (KPOW)',
        description: 'A real-time, market-implied measure of federal power across the Presidency, House, and Senate.',
        status: 'live',
    },
    // Fixed-size index widget with no user-facing config yet. Theme/UTM are hidden
    // until the /external-widgets/indices/kpow route reads those query params.
    fields: [
        { kind: 'theme', key: 'colorTheme', label: 'Theme', defaultValue: 'light', hidden: true },
        {
            kind: 'dimensions',
            key: 'dimensions',
            label: 'Dimensions',
            defaultValue: { width: '100%', height: '560px' },
            fixed: { width: '100%', height: '560px' },
            hidden: true,
        },
        { kind: 'boolean', key: 'showBorder', label: 'Border', defaultValue: false },
        { kind: 'boolean', key: 'rounded', label: 'Rounded corners', defaultValue: false },
    ],
    preview: { kind: 'direct-iframe' },
    embed: { kind: 'direct-iframe', fixed: {}, iframePath: '/external-widgets/indices/kpow' },
    fullscreenUrl: 'https://kalshi.com/charts/broadcast/kpow',
    dataSource: {
        summary:
            'The American Power Index composite, its weighted components, and the hourly history behind the chart line.',
        requests: KPOW_REQUESTS,
        notes: [
            'history requires start_ts (unix seconds) and returns hourly points; the request 400s without it.',
            'The window is capped at 5000 hours, roughly 208 days.',
        ],
    },
};
